import { Box, CircularProgress } from '@mui/material'
// import { Box, Button, Card, CircularProgress, Grid } from '@mui/material'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
// import { Linker } from 'src/uiParts/Linker'

const YellStoryPosition: React.FC = () => {
  // const baseUrl = '/hard/yellStory/'
  const router = useRouter()
  useEffect(() => {
    router.replace('/hard/yellStory/infielder')
  }, [])
  return (
    <Box sx={{ display: 'flex' }} position={'absolute'} top={'100px'} left={'100px'}>
      <CircularProgress />
    </Box>
  )
  // return (
  //   <Box>
  //     <Box data-testid={'position-selection-page'} p={2}>
  //       硬式グラブ / Yell story / ポジション選択ページ
  //     </Box>
  //     <Box p={10}>
  //       <Card style={{ padding: '16px' }}>
  //         <Box>グラブ</Box>
  //         <Grid container>
  //           <Grid item>
  //             <Linker href={`${baseUrl}infielder`}>
  //               <Button variant={'contained'} color={'primary'} size={'large'}>
  //                 内野手用
  //               </Button>
  //             </Linker>
  //           </Grid>
  //         </Grid>
  //       </Card>
  //     </Box>
  //   </Box>
  // )
}

export default YellStoryPosition
